module.exports = __webpack_public_path__ + "img/10.ff448d8a.png";